// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__iKNkk","label":"Labeled_label__2hvDL","divider":"Labeled_divider__3wx4g"};